import { Badge } from "@/components/ui/badge";

export type ProjectStatus =
  "initial_contact" | "offer" | "confirmed" | "rejected";
export type ProjectType = "live" | "film" | "gfx_tracking" | "consultancy";

const statusLabels: Record<ProjectStatus, string> = {
  initial_contact: "Initial Contact",
  offer: "Offer",
  confirmed: "Confirmed",
  rejected: "Rejected",
};

const typeLabels: Record<ProjectType, string> = {
  live: "Live",
  film: "Film",
  gfx_tracking: "GFX & Tracking",
  consultancy: "Consultancy",
};

interface StatusBadgeProps {
  status: ProjectStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const variant = {
    initial_contact: "status-initial",
    offer: "status-offer",
    confirmed: "status-confirmed",
    rejected: "status-rejected",
  }[status] as
    "status-initial" | "status-offer" | "status-confirmed" | "status-rejected";

  return <Badge variant={variant}>{statusLabels[status]}</Badge>;
}

interface TypeBadgeProps {
  type: ProjectType;
}

export function TypeBadge({ type }: TypeBadgeProps) {
  const variant = {
    live: "type-live",
    film: "type-film",
    gfx_tracking: "type-gfx",
    consultancy: "type-consultancy",
  }[type] as "type-live" | "type-film" | "type-gfx" | "type-consultancy";

  return <Badge variant={variant}>{typeLabels[type]}</Badge>;
}

interface TypeBadgesProps {
  types: ProjectType[];
}

export function TypeBadges({ types }: TypeBadgesProps) {
  if (!types || types.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {types.map((type) => (
        <TypeBadge key={type} type={type} />
      ))}
    </div>
  );
}
